import React, { useEffect, useState } from "react";
import api, { resolveApiResourceUrl } from "../../lib/api";

export default function PublicNews() {
    const [news, setNews] = useState([]);
    useEffect(() => {
        api.get("/public/clubs/by-name/ASSMBB").then((r) =>
            api.get(`/public/clubs/${r.data.id}/news`).then((rr) => {
                const data = Array.isArray(rr.data)
                    ? rr.data
                    : rr.data.items || rr.data.news || [];

                setNews(data);
            })
        );
    }, []);
    return (
        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="public-news-page">
            <div className="text-xs uppercase tracking-[0.3em] text-orange-500 font-bold mb-3">Actualités</div>
            <h1 className="font-display text-4xl lg:text-5xl font-black mb-10">Toutes les news du club</h1>
            {news.length === 0 ? (
                <div className="text-slate-500">Aucune actualité publiée pour le moment.</div>
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {news.map((n) => (
                        <article key={n.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow">
                            {n.image_url && <img src={resolveApiResourceUrl(n.image_url)} alt={n.title} className="w-full h-48 object-cover" />}
                            <div className="p-6">
                                <div className="text-xs text-slate-500">{n.published_at?.slice(0, 10)}</div>
                                <h2 className="font-display font-bold text-slate-900 text-lg mt-1">{n.title}</h2>
                                {n.excerpt && <p className="text-sm text-slate-600 mt-2">{n.excerpt}</p>}
                                <p className="text-sm text-slate-700 mt-3 whitespace-pre-wrap line-clamp-4">{n.content}</p>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
}
